import React from 'react'
import { Query } from 'react-apollo'
import { ApplicationLicense } from '../applications-grid/shared'
import { AgentLanguage } from '../agent-language'
import { Application as QueryApplication } from '../../graphql/schema/types/application'
import { AttackStatus } from '../attack-status'
import { Role } from '@contrast-security-inc/base-types'
import { FetchPolicy } from 'apollo-client'
import {
  ApplicationLoaderPublicProps,
  ApplicationLoaderRenderProps,
  applicationQuery
} from '.'

interface QueryData {
  readonly application: QueryApplication
}

interface QueryVariables {
  readonly organizationID: string
  readonly applicationID: string
}

export const mapApplication = ({
  language,
  attackStatus,
  license,
  role,
  ...application
}: QueryApplication) => ({
  ...application,
  language: AgentLanguage.fromKey(language),
  attackStatus: attackStatus as AttackStatus,
  license: license as ApplicationLicense,
  role: role as Role
})

export const ApplicationLoader = ({
  applicationID,
  organizationID,
  fetchPolicy,
  renderLoading,
  renderLoaded
}: ApplicationLoaderPublicProps &
  ApplicationLoaderRenderProps & {
    readonly fetchPolicy: FetchPolicy
  }) => (
  <Query<QueryData, QueryVariables>
    query={applicationQuery}
    variables={{
      applicationID,
      organizationID
    }}
    fetchPolicy={fetchPolicy}
    errorPolicy="all"
  >
    {({ loading, data, ...props }) => {
      if (props.error) {
        console.error(props.error)
        throw new Error('Error caught when trying to load application')
      }

      if (loading) {
        return renderLoading()
      }

      const application =
        !!data && !!data.application ? data.application : undefined

      if (!application) {
        if (fetchPolicy === 'cache-only') {
          throw new Error('Application not found in cache')
        }
        throw new Error('Application not found')
      }

      return renderLoaded(mapApplication(application))
    }}
  </Query>
)
